import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'

/**
 * Standalone, auth-free 404 the TenantGate renders for invalid tenants
 * (unknown org subdomain, apex, or a reserved non-admin subdomain).
 */
const NotFoundPage: FC = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 3,
      bgcolor: '#fafafa',
    }}
  >
    <Stack spacing={1.5} alignItems="center">
      <Typography sx={{ fontWeight: 700, lineHeight: 1 }} variant="h1">
        404
      </Typography>
      <Typography color="text.primary" sx={{ fontWeight: 600 }} variant="h6">
        Organization not found
      </Typography>
      <Typography color="text.secondary" maxWidth={440} textAlign="center">
        The address you’ve entered doesn’t match any organization. Check the link and try again.
      </Typography>
    </Stack>
  </Box>
)

export default NotFoundPage
